<header class="navbar bg-dark text-white">
  <div class="container-fluid">
    <h1 class="h4 mb-0 d-flex align-items-center gap-3">
      <svg-icon src="/assets/txd-logo.svg"></svg-icon>
      Online Document Editor
    </h1>
  </div>
</header>
<div class="content-container">
  <div class="content-box m-5 p-5 shadow">
    <ng-content></ng-content>
  </div>
</div>
<footer class="d-flex flex-column justify-content-center mt-3 text-secondary">
  <h5 class="text-center mb-3 text-body text-opacity-75">Contact Information</h5>

  <div class="d-flex gap-5 justify-content-center">
    <div>
      <div>960 Coronado Blvd</div>
      <div>Universal City, TX 78148</div>
      <div class="mt-2">Phone: (210) 253-9506</div>
      <div class="mt-2">Mon - Fri &nbsp;8 a.m. - 5 p.m. CST</div>
    </div>

    <div class="d-flex flex-column align-items-start gap-1 ms-5">
      <div class="d-flex">
        <div class="footer-email-label text-primary text-opacity-75">Sales</div>
        <div>
          :
          <a href="mailto:sales@txdocs.com" class="text-secondary">sales&#64;txdocs.com</a>
        </div>
      </div>
      <div class="d-flex">
        <div class="footer-email-label text-primary text-opacity-75">Service</div>
        <div>
          :
          <a href="mailto:service@txdocs.com" class="text-secondary">service&#64;txdocs.com</a>
          <br />
        </div>
      </div>
      <div class="d-flex">
        <div class="footer-email-label text-primary text-opacity-75">Tech support</div>
        <div>
          :
          <a href="mailto:support@txdocs.com" class="text-secondary">support&#64;txdocs.com</a>
        </div>
      </div>
    </div>
  </div>

  <div class="text-center text-secondary text-opacity-75 fw-light mt-5 mb-3">
    © Copyright TXdocs - All Rights Reserved
  </div>
</footer>

